import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './View/Pages/LoginPage';
import AdminLayout from './View/Layout/AdminLayout';
import DashboardPage from './View/Pages/DashboardPage';
import ProductsPage from './View/Pages/ProductsPage';
import ProductDetailPage from './View/Pages/ProductDetailPage';
import CategoriesPage from './View/Pages/CategoriesPage';
import CategoryDetailPage from './View/Pages/CategoryDetailPage';
import OptionDetailPage from './View/Pages/OptionDetailPage';
import OrdersPage from './View/Pages/OrdersPage';
import OrderDetailPage from './View/Pages/OrderDetailPage';
import LanguagesPage from './View/Pages/LanguagesPage';
import SettingsPage from './View/Pages/SettingsPage';
import PagesListPage from './View/Pages/PagesListPage';
import PageEditorPage from './View/Pages/PageEditorPage';
import HeroSliderPage from './View/Pages/HeroSliderPage';
import HeroSlideEditorPage from './View/Pages/HeroSlideEditorPage';
import GiveawaysPage from './View/Pages/GiveawaysPage';
import GiveawayEditorPage from './View/Pages/GiveawayEditorPage';
import NewsletterPage from './View/Pages/NewsletterPage';
import SellRequestsPage from './View/Pages/SellRequestsPage';
import SearchRequestsPage from './View/Pages/SearchRequestsPage';
import DiscountCodesPage from './View/Pages/DiscountCodesPage';
import WithdrawalsPage from './View/Pages/WithdrawalsPage';
import ContactsPage from './View/Pages/ContactsPage';
import { LanguageProvider } from './Context/LanguageContext';
import { MobileGlobalStyle } from './App.style';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  const location = useLocation();
  return token ? children : <Navigate to="/login" replace state={{ from: location }} />;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <MobileGlobalStyle />
      <LanguageProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="products/:id" element={<ProductDetailPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="categories/:id" element={<CategoryDetailPage />} />
            <Route path="categories/:categoryId/options/:optionId" element={<OptionDetailPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:id" element={<OrderDetailPage />} />
            <Route path="sell-requests" element={<SellRequestsPage />} />
            <Route path="sell-requests/:id" element={<SellRequestsPage />} />
            <Route path="search-requests" element={<SearchRequestsPage />} />
            <Route path="search-requests/:id" element={<SearchRequestsPage />} />
            <Route path="discount-codes" element={<DiscountCodesPage />} />
            <Route path="withdrawals" element={<WithdrawalsPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="contacts/:id" element={<ContactsPage />} />
            <Route path="pages" element={<PagesListPage />} />
            <Route path="pages/:slug" element={<PageEditorPage />} />
            <Route path="hero-slider" element={<HeroSliderPage />} />
            <Route path="hero-slider/:id" element={<HeroSlideEditorPage />} />
            <Route path="giveaways" element={<GiveawaysPage />} />
            <Route path="giveaways/:id" element={<GiveawayEditorPage />} />
            <Route path="newsletter" element={<NewsletterPage />} />
            <Route path="languages" element={<LanguagesPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
};

export default App;
